module.exports = __webpack_public_path__ + "static/img/le-monde.4ced1ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/le-monde.png
// module id = IJ8n
// module chunks = 0